import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subServices: [],
  loading: false,
  error: null,
};

const subServiceSlice = createSlice({
  name: "subService",
  initialState,
  reducers: {
    fetchSubServices: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSubServicesSuccess: (state, action) => {
      state.loading = false;
      state.subServices = action.payload;
    },
    fetchSubServicesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSubServices,
  fetchSubServicesSuccess,
  fetchSubServicesFailure,
} = subServiceSlice.actions;

export default subServiceSlice.reducer;
